export type GoodsDetailTab = 'INFORMATION' | 'REVIEW' | 'SIZE' | 'INQUIRY';
export const GoodsDetailTabName: Record<GoodsDetailTab, string> = {
  INFORMATION: '상품정보',
  REVIEW: '리뷰',
  SIZE: '사이즈',
  INQUIRY: '문의',
};
